var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgVolumeOff(_ref) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 48,
    height: 48,
    viewBox: "0 -960 960 960",
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M817.522-42.434 684.391-176.13q-26.304 18.304-56.825 31.674-30.522 13.369-63.826 20.804V-193q19.043-5.87 37.717-12.956 18.673-7.087 34.847-19.392L483.74-380.043v254.523L263.956-345.869H95.477v-268.827h156.566l-217.174-220 46.957-46.957L865.044-90.956l-47.522 48.522Zm-25.26-241.044L744.74-332.13q20-33.435 29.5-71.076 9.5-37.64 9.5-77.794 0-103.322-60.566-184.379Q662.609-746.435 563.74-769v-69.348q126.261 28.565 206.522 128.326T850.523-481q0 52.696-14.848 102.826-14.848 50.131-43.413 94.696ZM658.827-418.043l-95.087-96.218v-132.826q48.695 23.13 77.739 68.261 29.044 45.13 29.044 98.826 0 16.13-3.066 31.761-3.065 15.63-8.63 30.196ZM483.74-595.391 365.043-715.784 483.74-834.48v239.089Zm-79.784 276.956v-142.087l-73.826-74.391H174.696v109.826h122.608l106.652 106.652Zm-36.913-179Z"
  })));
}
export default __webpack_public_path__ + "media/outlined/volume_off-1b6afd01.svg";
export { SvgVolumeOff as ReactComponent };